import renderCaptchaComponent, { createCaptchaComponent } from '../../components/turnstile/Captcha';
import initCaptchaInterceptor from '../../components/turnstile/CaptchaInterceptor';
import Sentry from '../../components/sentry';

document.addEventListener('DOMContentLoaded', () => {
    Sentry.getInstance();
    renderCaptchaComponent();
    initCaptchaInterceptor();
});

document.addEventListener('rerender-captcha', () => {
    renderCaptchaComponent();
    initCaptchaInterceptor();
});

document.addEventListener('render-captcha', (event: Event) => {
    if (!(event instanceof CustomEvent)) {
        return;
    }

    createCaptchaComponent(event.detail.input, event.detail.options, event.detail.ref);
});
